import './TopNav.scss';

import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase/firebaseConfig';
import api, { TRUSTED_DEVICE_KEY } from '../../services/api';

import logo from '../../assets/images/icons/logo.svg';
import profileIcon from '../../assets/images/icons/profile-icon.svg';
import signoutIcon from '../../assets/images/icons/logout.svg';
import chevronRight from '../../assets/images/icons/chevron-right.svg';
import MiamiClock from '../MiamiClock/MiamiClock';
import { TrendingUp, BookOpen, Users } from 'lucide-react';

const MENU = [
    { path: '/investor', label: 'Investor Dashboard', Icon: TrendingUp },
    { path: '/brand-book', label: 'Brand Book', Icon: BookOpen },
    { path: '/affiliates', label: 'Affiliates', Icon: Users },
];

// One row of the top-right menu; hover is in TopNav.scss.
function MenuRow({ icon, label, onClick }) {
    return (
        <div
            onClick={onClick}
            className='topnav__signout-row'
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '8px 10px', borderRadius: 8, cursor: 'pointer' }}
        >
            <div className='topnav__signout-left'>
                {icon}
                <p className='topnav__signout-left-text'>{label}</p>
            </div>
            <img className='topnav__signout-icon' src={chevronRight} alt='chevron pointing right'></img>
        </div>
    );
}

function TopNav() {
    const navigate = useNavigate();

    const [signoutModal, setSignoutModal] = useState(false);

    const signoutModalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (signoutModalRef.current && !signoutModalRef.current.contains(event.target)) {
                setSignoutModal(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Sign out also cancels "Remember this device" on the server, so the next sign-in gets a text.
    async function handleSignout() {
        // Short timeout: a slow server never blocks signing out.
        await api.post('/users/forget-admin-device', null, { timeout: 4000 }).catch(() => {});
        localStorage.removeItem(TRUSTED_DEVICE_KEY);
        auth.signOut()
            .then(() => {
                console.log('successful signout'); navigate('/signin')
            }).catch((err) => {
                console.log(`error signing out. this is the error: ${err}`)
            })
    }

    return (
        <section className='topnav'>

            <img className='topnav__logo' src={logo} alt='Zona official logo'></img>

            <div className='topnav__right'>
                {/* Miami time — canonical Zona timezone */}
                <MiamiClock />

                {/* Profile / logout */}
                <img
                    onClick={() => setSignoutModal(!signoutModal)}
                    className='topnav__right-user'
                    src={profileIcon}
                    alt='small circle with person'
                    style={{height: 30, width: 30}}
                ></img>
            </div>
            {
                signoutModal &&
                <div ref={signoutModalRef} className='topnav__signout' style={{ flexDirection: 'column', alignItems: 'stretch', justifyContent: 'flex-start', gap: 2, padding: 8, cursor: 'default', minWidth: 200 }}>
                    {MENU.map(({ path, label, Icon }) => (
                        <MenuRow
                            key={path}
                            icon={<Icon size={18} color='#fff' />}
                            label={label}
                            onClick={() => { setSignoutModal(false); navigate(path); }}
                        />
                    ))}
                    <MenuRow
                        icon={<img className='topnav__signout-icon' src={signoutIcon} alt='log out'></img>}
                        label='Log Out'
                        onClick={() => handleSignout()}
                    />
                </div>
            }
        </section>
    )
}

export default TopNav;
